import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DrawerComponent } from './drawer/drawer.component'
import { MaterialModule } from '@app/shared/material.module'
import { QuoteBreakdownModule } from '@app/shared/quote-breakdown/quote-breakdown.module'
import { QuoteImportantNotesComponent } from './quote-important-notes/quote-important-notes.component'
import { QuoteDrawerHeadingComponent } from '../quote-drawer-heading/quote-drawer-heading.component'
import { SalesProcessToolComponent } from './sales-process-tool/sales-process-tool.component'
import { BrandCallSourceHistoryComponent } from './brand-call-source-history/brand-call-source-history.component'

@NgModule({
	declarations: [DrawerComponent],
	imports: [
		CommonModule,
		MaterialModule,
		QuoteBreakdownModule,
		QuoteImportantNotesComponent,
		QuoteDrawerHeadingComponent,
		SalesProcessToolComponent,
		BrandCallSourceHistoryComponent
	],
	exports: [DrawerComponent],
})
export class DrawerModule { }
